import {StyleDeclarationValue, StyleSheet} from 'aphrodite';

import {isNavbarColored} from 'nav/navbar/NavBarColor';
import hoverAndActiveStyles from 'styles/hoverAndActiveStyles';
import {ITEM_SIZE_SIDE_NAVBAR} from 'styles/StyleConstants';
import * as Colors from 'ui-library/Colors';

// aphrodite doesn't export this for some reason
type CSSInputTypes = StyleDeclarationValue | false | null | void;

export function getTabStyles(isActive: boolean): Array<CSSInputTypes> {
  return [
    isNavbarColored() ? navBarIconStyles.coloredTab : navBarIconStyles.tab,
    isActive && (isNavbarColored() ? navBarIconStyles.coloredActive : navBarIconStyles.active),
    window.impersonating && navBarIconStyles.impersonating,
    window.impersonating && isActive && navBarIconStyles.impersonatingActive,
  ];
}

export const hoverStyles = {
  backgroundColor: Colors.BLUE_DARKER,
  color: Colors.WHITE,
  textDecoration: 'none',
};
const impersonatingHoverStyles = {
  backgroundColor: Colors.RED_DARK,
};
const coloredNavbarActiveStyles = {
  backgroundColor: 'rgba(0,0,0,0.1)',
};
export const navBarIconStyles = StyleSheet.create({
  tab: {
    outline: 'none',
    ...hoverAndActiveStyles(hoverStyles),
  },
  coloredTab: {
    outline: 'none',
    ...hoverAndActiveStyles(coloredNavbarActiveStyles),
  },
  overflowMenuIcon: {
    color: Colors.GRAY_LIGHT,
  },
  iconWrapper: {
    color: Colors.GRAY_LIGHT,
    cursor: 'pointer',
    display: 'block',
    height: ITEM_SIZE_SIDE_NAVBAR,
    position: 'relative',
  },
  active: hoverStyles,
  coloredActive: coloredNavbarActiveStyles,
  impersonating: hoverAndActiveStyles(impersonatingHoverStyles),
  impersonatingActive: impersonatingHoverStyles,
  icon: {
    fontSize: 14,
  },
  inner: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  activityIndicator: {
    borderColor: Colors.GREEN_LIGHT,
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 4,
    height: 8,
    width: 8,
    position: 'absolute',
    top: 23,
    right: 4,
  },
});
